export default "__VITE_ASSET__CsDj5CcP__"